export default {
    current_choice: '目前的選擇',
    book_now: '立即預訂',
    minimum_age: '超過{age}的唯一',
    excess_liability: '超額責任',
    security_deposit: '保證金',
    fuel_policy: '燃油政策',
    like_for_like: '喜歡又喜歡',
    full_to_full: '滿到滿',
    miles_per_rental: '{mileage} 每次租賃免費里程',
    km_per_rental: '{mileage} 每次租借免費公里數',
    unlimited_mileage: '不限里程',
    unlimited_mileage_km: '無限公里',
    non_amendable: '不可修改',
    non_refundable: '不退還',
    free_cancellation_until: '免費取消直至',
    basic_free_cancellation: '開始時間前最多48小時可免費取消',
    cancellation_in_line_with: '取消符合',
    tcs: 'T&amp;Cs',
    free_extras_on_collection: '收藏時可免費獲得兩項額外獎勵',
    glass_and_tyres_covered: '玻璃和輪​​胎被覆蓋',
    number_of_passengers: '乘客人數',
    number_of_bags: '袋數',
    fuel_type: '燃料類型',
    co2: 'CO2',
    aircon: '空調',
    transmission: '傳染',
    book_type: '書{type}',
    debit_card_deposit: '接受金融卡存款',
    fast_track_included: '包含快速通道',
    view_all: '查看全部',
}
